let language = {
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-TITLE": "Download invoice",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT": "No invoice information found for this order!",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT-LIST": "No invoice information found for",
    "PAYMENTS-DASHBOARD-ALERT-DOWNLOAD-CONTENT-EMPTY": "No item was selected",
    "PAYMENTS-DASHBOARD-PROOFING-ORDER-NONSUPPORT-INVOICE-DOWNLOADS":"Proofing orders do not support invoice downloads."
};

export { language }